import { ITeamDTO } from 'src/services/TeamService';
import { BACKEND_URL } from '../config';
import * as RestService from './RestService';

export interface IGroupDTO {
	 id: number;
	 uuid: String;
	 name: String;
	 externalUuid: String;
	 eventCategoryId: number;
	 eventCategoryName: String;
	 maxTeams: number;
	 deleted: Date;
   isKnockout: boolean;
}

const BASE_URL = BACKEND_URL + '/auth/generate-competition-by-schema'

export interface ApplySchemaDTO {
	eventCategoryId: any;
	schema: any;
	distributionModeId: any;
	teamLevelId?: number;
	teams?: ITeamDTO[];
	calendarConfigs: any;
}

/**
 * 
  Crea un grupo  
*/
 export const create = (data: ApplySchemaDTO) => {
  return RestService.post(`${BASE_URL}/create`, data);
}


/**
 * 
  check 
*/
export const check = (eventCategoryId: any ) => {
	return RestService.post(`${BASE_URL}/check/${eventCategoryId}`, {});
}
  